export default [
  {
    header: 'Обратная связь',
    resource: 'feedback',
    action: 'view',
  },
  {
    title: 'Статистика отзывов',
    route: 'feedback-stats',
    icon: 'MessageSquareIcon',
    tagVariant: 'light-warning',
    resource: 'feedback',
    action: 'view',
  },
]
